/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventdraftdiscard2Inputs */

const en_eventdraftdiscard2 = /** @type {(inputs: Eventdraftdiscard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discard`)
};

const de_eventdraftdiscard2 = /** @type {(inputs: Eventdraftdiscard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwerfen`)
};

/**
* | output |
* | --- |
* | "Discard" |
*
* @param {Eventdraftdiscard2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventdraftdiscard2 = /** @type {((inputs?: Eventdraftdiscard2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventdraftdiscard2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventdraftdiscard2(inputs)
	return de_eventdraftdiscard2(inputs)
});
export { eventdraftdiscard2 as "eventDraftDiscard" }